module.exports = __webpack_public_path__ + "media/images/no_processors-4ac78da99f6c3d0719e120e5e46ba93e.svg";